import { ConnectedDisconnected } from '@reliance/types/enums/ConnectedDisconnected';
import { EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import { type Station } from '@reliance/types/models/Station';
import { type ApiService } from '../types/ApiService';

export const station = (siteApi: ApiService) => ({
  index: (params?): Promise<Station[]> => {
    return siteApi
      .get<Station[]>('/station', { params })
      .then((stations: Station[]) => {
        stations = stations.map((s) => {
          s.stationStatus = {
            status: s.stationStatus?.status ?? EnabledDisabled.ENABLED,
            freeswitch:
              s.stationStatus?.freeswitch ?? ConnectedDisconnected.DISCONNECTED,
            connectServer:
              s.stationStatus?.connectServer ??
              ConnectedDisconnected.DISCONNECTED,
            inCall: s.stationStatus?.inCall ?? false,
            inUse: s.stationStatus?.inUse ?? false,
          };
          return s;
        });
        return stations;
      });
  },
  putStatus: (id: number, newStatus: EnabledDisabled): Promise<void> => {
    return siteApi.put(`/station/status/${id}`, { newStatus });
  },
  putMultipleStatus: (ids, newStatus) => {
    return siteApi.put('/station/multiple/status', {
      ids: ids.join(','),
      newStatus,
    });
  },
});
